/* eslint-disable */
import React, { Component } from "react";
import cookie from "react-cookies";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

class SpendingAnalysis extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    let selectedoutletArr = props.selectedoutletData;
    let selectedMerchants = [];
    let selectedMerchantData = [];
    if(selectedoutletArr != "" && Object.keys(selectedoutletArr).length > 0) {
        selectedMerchantData = props.selectedoutletData;
        selectedMerchants = selectedoutletArr.map(selectedOutlt => selectedOutlt.outletid);
    }
    this.state = {
      companyID: '',
      clearOulet: 'No',
      selectedMerchants: selectedMerchants,
      selectedMerchantData: selectedMerchantData
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(nextProps.clearOulet !== this.state.clearOulet) {
      let selectedMerchants = this.state.selectedMerchants;
      let selectedMerchantData = this.state.selectedMerchantData;
      if(nextProps.clearOulet == 'Yes') {
          selectedMerchants = [];
          selectedMerchantData = [];
      }
      this.setState({clearOulet: nextProps.clearOulet, selectedMerchants: selectedMerchants, selectedMerchantData: selectedMerchantData}, function() {
            if(nextProps.clearOulet == 'Yes') {
                this.props.sateValChange('clearOulet', 'No');
            }
      });
    }
  }

  componentDidMount() {

  }

  handleMerchantClick = (outletData) => {
    let outletid = outletData.outletid;
    let outletArr = {'name':outletData.name,'outletid':outletData.outletid};
    let selectedMerchants = this.state.selectedMerchants;
    let selectedMerchantData = this.state.selectedMerchantData;
    if (selectedMerchants.includes(outletid)) {
      var itemIndx = selectedMerchants.indexOf(outletid);
          selectedMerchants.splice(itemIndx,1);
          selectedMerchantData.splice(itemIndx,1);
         this.setState({ selectedMerchants: selectedMerchants, selectedMerchantData: selectedMerchantData}, function () {
            this.props.sateValChange('selectedoutlet', selectedMerchantData);
         });
    } else {
      var itemIndx = Object.keys(selectedMerchants).length;
      let sltMrcht = [...selectedMerchants, outletid];
          selectedMerchantData[itemIndx] = outletArr;
          this.setState({ selectedMerchants: sltMrcht, selectedMerchantData: selectedMerchantData}, function () {
             this.props.sateValChange('selectedoutlet', selectedMerchantData);
          });
    }
  };

  handleMerchantClickOld = (outletid) => {
    let selectedMerchants = this.state.selectedMerchants;
    if (selectedMerchants.includes(outletid)) {
      this.setState({ selectedMerchants: selectedMerchants.filter(m => m !== outletid)}, function () {
        this.props.sateValChange('selectedoutlet', this.state.selectedMerchants);
      });
    } else {
      this.setState({ selectedMerchants: [...selectedMerchants, outletid]}, function () {
        this.props.sateValChange('selectedoutlet', this.state.selectedMerchants);
      });
    }
  };

  handleClick = (data) => {
    alert(`Filtering by ${data.name}`);
    // You could set a filter or state update here 
  }

  getCustomerInfo(custData) {
      if(Object.keys(custData).length > 0 && custData.customerID != undefined && custData.customerID != ""  && custData.customerID != null) {
        this.props.openTragerPopup(custData.customerID);
      }
  }

  render() {
    let spendingOutletData = [];
    let spendingCustomerData = [];
    if(Object.keys(this.props.spendingOutletData).length > 0) {
        spendingOutletData = this.props.spendingOutletData;
    }
    if(Object.keys(this.props.spendingCustomerData).length > 0) {
        spendingCustomerData = this.props.spendingCustomerData;
    }
    let selectedMerchants = this.state.selectedMerchants;

    return (<div className="spending_analysis_row">

              <div className="spending_analysis_col1 barchart_maindiv">
                  <div className="card barchart_innerdiv">
                    <h5 className="barchart_header">Spending by Merchant</h5>
                    <p className="barchart_header_info">
                      Click on bars to filter by merchant
                    </p>
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart data={spendingOutletData} margin={{ top: 10, right: 5, left: -10, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="1 3" />
                        <XAxis dataKey="name" tick={{ fontSize: 12 }} tickFormatter={(value) => value.length > 9 ? value.substring(0, 9) + "..." : value} />
                        <YAxis domain={[0, 'auto']} tick={{ fontSize: 12 }} />
                        <Tooltip contentStyle={{ paddingTop: '2px', paddingBottom: '2px', fontSize: '12px' }} />
                        <Bar
                          dataKey="value"
                          fill="#4B4DED"
                          onClick={(data) => this.handleMerchantClick(data)}
                          cursor="pointer"
                          barSize={42}
                        >
                        {spendingOutletData.map((entry, index) => (
                        <Cell 
                          key={`cell-${index}`} 
                          fill={selectedMerchants.includes(entry.outletid) ? '#0fcb34' : '#4f46e5'}
                        />
                        ))}
                      </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </div>  
              </div>

              <div className="spending_analysis_col2 topspenders_maindiv">
                <div className="card topspenders_innerdiv">
                    <h5 className="topspenders_header">Top Spenders</h5>
                    <div className="topspenders_table_maindiv">
                      <table className="topspenders_table" style={{width:"100%"}}>
                        <tr>
                          <th style={{width:"40%"}}>Name/Mobile</th>
                          <th style={{width:"30%"}}>Purchases</th>
                          <th style={{width:"30%"}}>Total Spent</th>
                        </tr>
                        
                        {spendingCustomerData.length > 0 && (
                          spendingCustomerData.map((item, index) => {
                            return (
                              <tr key={index} onClick={this.getCustomerInfo.bind(this,item)}>
                                <td>{item.customerName}</td>
                                <td>{item.totalTrans}</td>
                                <td>${item.transAmount}</td>
                              </tr>
                            );
                          })
                        )}  
                      </table>
                    </div>
                </div>   
              </div>
                 
          </div>);
  }
}

export default (SpendingAnalysis);
